import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const impactDecisionRecommendationStyles = makeStyles((theme: Theme) =>
    createStyles({
        message: {
            padding: "0px 0px 10px 25px",
            display: "flex",
        },
        supported: { color: "#008C34" },
        notSupported: { color: "#BE442A" },
        smallIndicator: {
            height: "20vh",
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
        },
        recommendation: { padding: "0px 0px 10px 25px" },
        iconUp: {
            marginTop: "-2px",
        },
        iconDown: {
            marginTop: "2px",
        },
    })
);
